export default __webpack_public_path__ + "static/media/course4.1a5422d1.webp";